import { Box, Tooltip, Typography } from '@rossum/ui/material';
import clsx from 'clsx';
import EyeOffIcon from 'mdi-react/EyeOffIcon';
import { useIntl } from 'react-intl';
import { OriginalAnyDatapointSchema } from '../../../../../types/schema';
import { isFieldRequired } from '../helpers';
import scrollingSubject from '../lib/scrollingSubject';
import styles from '../styles.module.sass';
import { sharedStyles } from './sharedStyles';

const typeSwitch = ({
  type,
  format = '',
}: Pick<OriginalAnyDatapointSchema, 'format' | 'type'>) => {
  switch (type) {
    case 'string':
      return 'String';
    case 'date':
      return `Date (${format})`;
    case 'number':
      return 'Number';
    default:
      return null;
  }
};

const Datapoint = ({
  label,
  constraints,
  hidden,
  id,
  format,
  type,
  inFooter,
  toggleCurrent,
}: Pick<
  OriginalAnyDatapointSchema,
  'label' | 'constraints' | 'hidden' | 'type' | 'format' | 'id'
> & { inFooter?: boolean; toggleCurrent: () => void }) => {
  const intl = useIntl();
  return (
    <Box
      data-cy="datapoint-item"
      sx={inFooter ? {} : sharedStyles}
      onClick={() => {
        scrollingSubject.next(id);
        toggleCurrent();
      }}
    >
      {!inFooter && (
        <Box
          data-cy="datapoint-title"
          className={styles.TitleEncapsulor}
          sx={{
            flex: '0 1 auto',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            mr: 1,
            '&::selection': {
              backgroundColor: t => t.palette.action.selected,
            },
          }}
        >
          <Typography>
            {label}

            {isFieldRequired(constraints, type) && (
              <Tooltip
                title={intl.formatMessage({
                  id: 'containers.settings.queues.schema.sidebar.required',
                })}
              >
                <span className={styles.Requirer}>&nbsp;*</span>
              </Tooltip>
            )}
          </Typography>
          {hidden && <EyeOffIcon className={styles.HiddenIcon} />}
        </Box>
      )}
      <div className={clsx(!inFooter && styles.DatapointValue)}>
        <Typography>{typeSwitch({ format, type })}</Typography>
      </div>
    </Box>
  );
};

export default Datapoint;
